import { useMemo } from 'react';

import { useExpensePolicyPreview } from './useExpensePolicyPreview';
import { describeEntryPolicy } from './expensePolicyHelpers';

// Talep giriş formunun politika kaynağı. Tutarın nereden geldiği tipe bağlıdır:
// avansta elle yazılır, masrafta fiş toplamıdır — müşterinin şikayet ettiği an
// (limit üstü fiş eklenmesi) ikincisidir.
export function useExpenseEntryPolicy({
  expenseType, categoryId, currency = 'TRY', totalAmount, receiptsTotal, categories,
}) {
  const effectiveTotal = expenseType === 'advance'
    ? (parseFloat(totalAmount) || 0)
    : (Number(receiptsTotal) || 0);

  const { preview, loading } = useExpensePolicyPreview({
    categoryId, amount: effectiveTotal, currency,
  });

  const category = useMemo(
    () => (categories || []).find((c) => c.id === categoryId) || null,
    [categories, categoryId],
  );

  const entryPolicy = useMemo(() => describeEntryPolicy({
    preview,
    fallback: {
      perTransactionLimit: category?.perTransactionLimit ?? null,
      totalAmount: effectiveTotal,
      currency,
    },
  }), [preview, category, effectiveTotal, currency]);

  // Henüz aşım yokken bile limiti göster: çalışan fişi eklemeden önce sınırı bilsin.
  const categoryHint = useMemo(() => {
    if (entryPolicy) return null;
    if (currency !== 'TRY') return null;
    return category?.perTransactionLimit ?? null;
  }, [entryPolicy, category, currency]);

  return { entryPolicy, categoryHint, effectiveTotal, loading };
}

export default useExpenseEntryPolicy;
